import { TypeaheadResultsItem } from '../Typeahead';
import { isOptionGroup as _isOptionGroup } from './Select.types';
import { getCheckboxState, isVirtualized } from './Select.helpers';
import { getAriaAndDataProps } from '../../utils/Props';
import { StyledMultiValueWrapper, StyledDropdownFooterContainer, StyledCollapsedAnchorSelectControl, StyledTypeaheadResultsSpan, StyledSelectArrow, StyledArrowZone, StyledDropdownResults } from './Select.styles';
import { MultiSelectValue } from './MultiSelectValue';
import { Clickable } from '../Clickable/Clickable';
import { Button } from '../Button/Button';
import unescapedText from 'I18n/utils/unescapedText';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const createRenderers = component => ({
  defaultOptionRenderer: option => {
    const {
      anchorType = 'auto',
      itemComponent = 'span',
      multi,
      optionComponent,
      value
    } = component.props;
    const isOptionGroup = _isOptionGroup(option);
    const isSelectAll = isOptionGroup && !!option.selectAll;
    const toggleable = component.areOptionsToggleable({
      anchorType,
      multi
    }) && option.className !== 'Select-create-option-placeholder' && !option.isSpecial && !(isOptionGroup && !isSelectAll);
    const {
      indeterminate,
      checked
    } = getCheckboxState(option, value);
    return /*#__PURE__*/_jsx(TypeaheadResultsItem, {
      itemComponent: optionComponent || itemComponent,
      isIndeterminate: toggleable && indeterminate,
      isSelected: toggleable && checked,
      help: option.help,
      onToggle: toggleable ? component.handleOptionToggle.bind(component, option) : undefined,
      option: option,
      toggleable: toggleable,
      _useButton: !toggleable
    });
  },
  defaultValueRenderer: option => {
    const {
      itemComponent = 'span',
      valueComponent
    } = component.props;
    return /*#__PURE__*/_jsx(TypeaheadResultsItem, {
      "aria-invalid": option.invalid,
      itemComponent: valueComponent || itemComponent,
      help: option.help,
      option: Object.assign({}, option, {
        help: undefined
      }),
      _useButton: false,
      _useDropdownText: false
    }, `${option.value}`);
  },
  renderDropdownContent(props) {
    const {
      dropdownFooter,
      loadOptions,
      menuRenderer,
      searchable = true,
      menuHeight,
      menuStyles
    } = component.props;
    return /*#__PURE__*/_jsx(StyledTypeaheadResultsSpan, {
      "data-dropdown-results": true,
      "data-async-options": !!loadOptions,
      $menuHeight: menuHeight,
      children: /*#__PURE__*/_jsxs(StyledDropdownResults, {
        $anchorType: component.getAnchorType(component.props),
        ref: component.dropdownContentRefCallback,
        style: {
          width: component.getMenuWidth()
        },
        $isVirtualized: !!isVirtualized(menuRenderer),
        $searchable: searchable,
        $menuHeight: menuHeight,
        $menuStyles: menuStyles,
        $hasDropdownFooter: !!dropdownFooter,
        className: "fnd-select",
        children: [props.children, component.renderDropdownFooter()]
      })
    });
  },
  renderDropdownFooter() {
    const {
      dropdownFooter
    } = component.props;
    if (!dropdownFooter) {
      return null;
    }
    return /*#__PURE__*/_jsx(StyledDropdownFooterContainer, {
      children: dropdownFooter
    });
  },
  renderCollapsedAnchor(error, multiCollapseLimit, multi, value, valueRenderer, rest) {
    const {
      optionsCache
    } = component.state;
    // TODO(TS): we don't do a good job of tracking whether SelectValue is an array or not
    const renderedValues = value.slice(0, multiCollapseLimit).map(v => {
      const option = optionsCache[`${v}`] || {
        text: v,
        value: v
      };
      const valueNode = (valueRenderer || component.defaultValueRenderer)(option);
      return /*#__PURE__*/_jsx(MultiSelectValue, {
        closeable: false,
        disabled: option.disabled,
        value: option,
        children: valueNode
      }, v);
    });
    const hiddenValueCount = value.length - renderedValues.length;
    const andMoreNode = hiddenValueCount > 0 ? /*#__PURE__*/_jsx(Button, {
      "data-hidden-value-count": hiddenValueCount,
      use: "transparent",
      children: unescapedText('salesUI.UISelect.plusMore', {
        count: hiddenValueCount
      })
    }) : null;

    // We use the same classnames as react-select here, to get the same appearance.
    return /*#__PURE__*/_jsx(Clickable, Object.assign({}, getAriaAndDataProps(rest), {
      "data-collapsed": true,
      onClick: component.triggerOpen,
      onFocus: component.triggerOpen,
      inlineSize: "100%",
      children: /*#__PURE__*/_jsxs(StyledCollapsedAnchorSelectControl, {
        "aria-invalid": error // required for correct error styles for collapsed anchor
        ,
        className: "Select-control",
        $multi: multi,
        children: [/*#__PURE__*/_jsxs(StyledMultiValueWrapper, {
          className: "Select-multi-value-wrapper",
          children: [renderedValues, andMoreNode]
        }), /*#__PURE__*/_jsx(StyledArrowZone, {
          className: "Select-arrow-zone",
          $multi: multi,
          children: /*#__PURE__*/_jsx(StyledSelectArrow, {
            className: "Select-arrow"
          })
        })]
      })
    }));
  }
});